const instructionsDataInitial = [
  {
    id: "filling",
    name: "Make filling",
    steps: [
      { text: "In a large Dutch oven, heat 2 Tbsp of *vegetable oil* over medium heat until shimmering" },
      { text: "Add #onion#, #salt#, and #baking soda# and cook, stirring occasionally, until onion has broken down into a soft paste and is just starting to stick to pot, 6 to 8 minutes" },
      { text: "Add #beans#, #black pepper#, and #Aleppo pepper# and cook until mixture is hot, about 2 minutes" },
      { text: "Remove pot from heat and, using a potato masher or pastry cutter, mash beans to form a coarse paste" },
      { text: "Fold in cilantro, parsley, and dill. Taste for seasoning and add more salt to taste. Cover and let cool to room temperature." }
    ]
  },
  {
    id: "sauce",
    name: "Make sauce",
    steps: [
      { text: "Place #parsley#, #cilantro#, #olive oil#, #dill#, #lemon juice#, #garlic#, #Aleppo pepper#, #salt#, and #cumin# in the jar of a countertop blender or food processor and process until just smooth, 15 to 30 seconds. Taste and add more salt if needed." },
      { text: "Transfer to a serving bowl and set aside.", note: "Sauce may be refrigerated in an airtight container for up to 24 hours" }
    ]
  },
  {
    id: "assemble",
    name: "Assemble",
    steps: [
      { text: "Place 1 Tbps *vegetable oil* on a rimmed baking sheet and, using a brush, spread evenly on bottom of sheet" },
      { 
        text: `Cut #lavash# into sixteen strips, each 11" long by 3" wide`,
        note: "Keep cut lavash covered or in a plastic bag so strips don’t dry out"
      },
      { text: "Lay 3 or 4 lavash strips on the countertop side by side, with short ends facing edge of countertop. Using a mister bottle, lightly spray both sides of each strip with water to soften." },
      { text: "Using a ¼ cup measure, place scant 3 tablespoons (about 40g) filling on the bottom left-hand corner of one strip, about one inch from the bottom edge, and shape it into a triangle. Working gently, lift the bottom right corner of the lavash and fold it over the filling and gently press to form a right triangle. Continue folding up and over, like folding a flag, until you reach the end of lavash strip. Using a sharp knife, trim off any overhanging lavash." },
      { text: "Using a sharp knife, trim off any overhanging lavash. Place the triangle seam-side down on the prepared sheet and repeat with the remaining three strips." },
      { text: "Repeat with remaining strips, in groups of 3 or 4, arranging triangles in pairs with long edges facing each other, so that they form four rows of four triangles." },
      { 
        text: "Cover tray and allow to rest at room temperature for at least 30 minutes.",
        note: "alternatively, refrigerate tray for up to two hours"
      }
    ]
  },
  {
    id: "bake",
    name: "Bake",
    steps: [
      { text: "Set an oven rack to the middle position and heat oven to _350°F_" },
      { text: "When oven is ready, place remaining ⅓ cup oil in a small bowl. Using a brush, thoroughly coat both sides of each triangle with oil and return to tray, seam-side down." },
      { 
        text: "Bake until golden and crisp on one side, 12–15 minutes. Remove sheet pan from oven, brush tops of triangles with oil and then drizzle any oil remaining in bowl over them.",
        timer: 12 
      },
      { 
        text: "Flip each triangle over, and continue to bake until they are golden brown and crisp on both sides, 12 to 15 minutes longer.",
        timer: 12 
      },
      { text: "Remove baking sheet from oven, and let triangles cool at least 5 minutes before serving (don't forget the sauce!)." }
    ]
  }
]

function importAll(r) {
  return r.keys().map(r);
}

// this is a different approach where we only import media from the top level
// folder (media/instructions), which is done by setting 'false' instead of 'true'
// since the file name already has the sectionId in it, we don't need to put the files
// into separate folders
const allMedia = importAll(require.context('./media/instructions', false, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
  const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
  if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
  acc[sectionId].push(path); // Add path to array
  return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
  // if there's an array of media for the given section
  if (mediaBySection[section.id]) {
      // add media array
      return { ...section, media: mediaBySection[section.id] };
  } else {
      return section;
  }
})